import { render, staticRenderFns } from "./IconUserSilhouette.vue?vue&type=template&id=4340f194&"
import script from "./IconUserSilhouette.vue?vue&type=script&lang=js&"
export * from "./IconUserSilhouette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports